import React from 'react';

function Simulation() {
  return (
    <div>
      <h1>Simulation Page</h1>
      <p>Ici tu pourras lancer une simulation.</p>
    </div>
  );
}

export default Simulation;
